import React from 'react';
import { CheckIcon, TrophyIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
import { ScarcityBar } from './ScarcityBar';
const includedPerks = ['One-time payment', '1-year access', 'No monthly fees', 'Instant access'];
export function OfferSection() {
  return <section id="offer" className="w-full bg-navy-950 py-14 sm:py-20" data-id="element-223" data-mp="dfq0isi8o5i4">
      <div className="mx-auto w-full max-w-2xl px-4 sm:px-6" data-id="element-224" data-mp="idzvb201x437">
        <div className="text-center" data-id="element-225" data-mp="ifkux6183d7x">
          <p className="inline-flex items-center gap-1.5 rounded-full bg-gold-500 px-3.5 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-navy-900" data-id="element-226" data-mp="me1xdc9p7zj0">
            <TrophyIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-227" data-mp="wczis6btvcxs" />
            Special launch offer
          </p>
          <h2 className="mt-5 font-display text-[26px] font-bold leading-[1.15] text-cream-100 sm:text-4xl" data-id="element-228" data-mp="2t5t0ysrdo50f">
            Here’s everything{' '}
            <em className="not-italic text-gold-400" data-id="element-229" data-mp="2y4w4g8rpm36a">you’ll get today</em>
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl border border-gold-500/30 bg-navy-900" data-id="element-230" data-mp="12ote9ddkr5gw">
          <ul className="divide-y divide-cream-100/10" data-id="element-231" data-mp="xvh3a61tix6m">
            <li className="flex items-center justify-between gap-3 p-4 sm:p-5" data-id="element-232" data-mp="sx747kcz3cfq">
              <span className="text-[14.5px] font-semibold text-cream-100" data-id="element-233" data-mp="owdjezutudr2">
                📘 Occlusion 360™ — 6 Premium Volumes
              </span>
              <span className="shrink-0 text-[14px] font-bold text-gold-300" data-id="element-234" data-mp="1llumd72fdlp2">
                $97
              </span>
            </li>
            <li className="flex items-center justify-between gap-3 p-4 sm:p-5" data-id="element-235" data-mp="1glgky7vbxa00">
              <span className="text-[14.5px] font-semibold text-cream-100" data-id="element-236" data-mp="1cnsq14tmzh84">
                🎁 5 Professional Bonuses
              </span>
              <span className="shrink-0 text-[14px] font-bold text-gold-300" data-id="element-237" data-mp="172ed66g1x74">
                $147
              </span>
            </li>
            <li className="flex items-center justify-between gap-3 bg-navy-800 p-4 sm:p-5" data-id="element-238" data-mp="3sc119ekh12gj">
              <span className="text-[12px] font-extrabold uppercase tracking-[0.14em] text-cream-100/70" data-id="element-239" data-mp="3tvawoazb9qgd">
                Total value
              </span>
              <span className="shrink-0 font-display text-2xl font-bold text-cream-100/60 line-through" data-id="element-240" data-mp="3ktbal49fvw6k">
                $244
              </span>
            </li>
          </ul>

          <div className="border-t border-gold-500/30 bg-navy-950 px-5 py-7 text-center sm:px-8" data-id="element-241" data-mp="3owzkvupgh5vi">
            <p className="text-[12px] font-bold uppercase tracking-[0.14em] text-gold-400" data-id="element-242" data-mp="3b1f3j3pdkvq7">
              Today, you can get everything for just…
            </p>
            <p className="mt-3 font-display text-[56px] font-bold leading-none text-cream-100 sm:text-7xl" data-id="element-243" data-mp="316n55xnyy4ud">
              $27
              <span className="ml-1 align-top text-base font-bold tracking-wide text-gold-400 sm:text-xl" data-id="element-244" data-mp="364oqkp8vag90">
                USD
              </span>
            </p>

            <ul className="mx-auto mt-6 grid w-full max-w-sm grid-cols-2 gap-2" data-id="element-245" data-mp="2x2p43hf32jyo">
              {includedPerks.map(perk => <li key={perk} className="flex items-center gap-2 rounded-xl bg-navy-800 px-3 py-2.5 text-left" data-id="element-246" data-mp="2di749367m6zx">
                  <CheckIcon className="h-3.5 w-3.5 shrink-0 text-clinical-green" aria-hidden="true" data-id="element-247" data-mp="2mjofo88o9kia" />
                  <span className="text-[12.5px] font-semibold leading-tight text-cream-100" data-id="element-248" data-mp="2wgt5ci1q7y3u">
                    {perk}
                  </span>
                </li>)}
            </ul>

            <p className="mx-auto mt-6 max-w-md text-[13.5px] leading-relaxed text-cream-100/65" data-id="element-249" data-mp="366mezdib635g">
              For less than the cost of a small portion of the time lost dealing
              with unnecessary rework, you’ll have a professional reference system
              you can return to whenever you need to organize your occlusal
              analysis.
            </p>

            <div className="mt-7" data-id="element-250" data-mp="3a64pdfci6vu1">
              <CTAButton label="Yes — I want Occlusion 360™" subline="One-time payment of $27 · Instant access · 7-day guarantee" data-id="element-251" data-mp="18jjxzjdxqju6" />
            </div>

            <div className="mt-8" data-id="element-252" data-mp="1i93jkwt18rsq">
              <Countdown tone="dark" data-id="element-253" data-mp="1ia4rwtinz06r" />
              <p className="mt-4 text-center text-[11px] font-bold uppercase tracking-[0.14em] text-gold-400" data-id="element-254" data-mp="1ib7kr6zjrcpb">
                Limited-time launch price
              </p>
              <div className="mt-4" data-id="element-255" data-mp="plqv2h3ba9ws">
                <ScarcityBar tone="dark" data-id="element-256" data-mp="uj974gcml590" />
              </div>
              <p className="mt-3 text-[12px] leading-snug text-cream-100/60" data-id="element-257" data-mp="ujslxo6zbdit">
                Currency conversion is handled automatically according to your
                country — you pay the equivalent of $27 USD in your local currency.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}